export const AUTH_URL = "https://auth.myeverlights.com/api";
export const APPSERVER_URL = "https://appserver-v2.myeverlights.com";
export const TELEMETRYSERVER_URL = "https://telemetry-v2.myeverlights.com";
export const REMOTE_SERVER_URL = "https://remote.myeverlights.com";
export const UPDATE_URL = "https://update.myeverlights.com/";
// Standalone bridge-backup service (snapshot list/read + manual "back up now").
// ASSUMPTION: hostname follows the sibling services' convention above; the
// bridge-backup API surface (src/api.ts) is not deployed yet as of this
// writing (see SUPPORT_TOOL_BACKUP_UI_PLAN.md phase 1) — confirm/adjust this
// once it ships.
export const BACKUP_URL = "https://bridge-backup.myeverlights.com";
